import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const EditIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue3c9'}</MuiIcon>
        );
    })
